<template>
	<v-card>
		<v-card-title :class="color" class="pb-1 pt-1 mt-2">
			{{ title }}
		</v-card-title>
		<v-card-text class="py-0" v-if="title != 'Statistics:'">
			<v-timeline dense>
				<v-slide-x-reverse-transition group hide-on-leave>
					<v-timeline-item
							class="pb-3"
							v-for="(item, index) in dataList"
							:key="index"
							:color="color"
							small
					>
						<editor
								:save-marker="saveMarker"
								:color="color"
								:data-item="item"
						/>
					</v-timeline-item>
				</v-slide-x-reverse-transition>
			</v-timeline>
		</v-card-text>
		<!-- For statistics -->
		<v-card-text>
			<v-form v-model="valid" @submit.prevent>
				<v-container>
					<v-row class="align-center mt-5" v-if="title === 'Statistics:'">
						<v-col cols="12" sm="6">
							<v-row class="justify-start">
								<v-timeline dense>
									<v-timeline-item small class="pb-3"></v-timeline-item>
								</v-timeline>
								<v-col cols="12" sm="6">
									<v-select
											:items="dispatchers"
											required
											item-value="employee_id"
											item-text="personal_name"
											label="Dispatch manager"
											dense
											@change="log"
											return-object
											v-model="selectedMgr"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6">
							<span class="ml-auto">Phone number: {{ selectedMgr ? selectedMgr.phone : '' }}</span>
						</v-col>
						<v-col cols="12" sm="6">
							<v-row class="justify-start">
								<v-timeline dense>
									<v-timeline-item small class="pb-3"></v-timeline-item>
								</v-timeline>
								<v-col cols="12" sm="6">
									<v-select
											:items="dispatchers"
											required
											item-value="employee_id"
											item-text="personal_name"
											label="Safety Manager"
											dense
											return-object
											v-model="selectedSft"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6">
							<span class="ml-auto">Phone number: {{ selectedSft ? selectedSft.phone : '' }}</span>
						</v-col>
						<v-col cols="12" sm="6">
							<v-row class="justify-start">
								<v-timeline dense>
									<v-timeline-item small class="pb-3"></v-timeline-item>
								</v-timeline>
								<v-col cols="12" sm="6">
									<v-select
											required
											:items="dispatchers"
											item-value="employee_id"
											item-text="personal_name"
											label="Sales"
											dense
											return-object
											v-model="selectedSls"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6">
							<span>Phone number: {{ selectedSls ? selectedSls.phone : '' }}</span>
						</v-col>
						<v-col cols="12" sm="6">
							<v-row class="justify-start">
								<v-timeline dense>
									<v-timeline-item small class="pb-3"></v-timeline-item>
								</v-timeline>
								<v-col cols="12" sm="6">
									<v-text-field
											ref="afterHrs"
											required
											v-model="afterHrs"
											@keypress="afterHoursPhone($event)"
											type="text"
											:rules="phoneRules"
											label="Afterhours"
									></v-text-field>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="6">
							<span>Phone number: {{ afterHrs ? afterHrs : '' }}</span>
						</v-col>
					</v-row>
				</v-container>
			</v-form>
		</v-card-text>
	</v-card>
</template>
<script>
import Editor from "./editor/editor.component";

export default {
	components: {
		Editor,
	},
	props: {
		dispatchers: Array,
		dataList: Array,
		title: String,
		color: String,
		saveMarker: Boolean,
		statisticsData: Array,
	},
	data() {
		return {
			edit: false,
			statData: [],
			settingsData: [],
			phoneRules: [
				(v) =>
					/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/g.test(v) ||
						"Phone must be valid as like this xxx-xxx-xxxx",
			],
			valid: false,

		};
	},
	computed: {
		datasSettings() {
			if (this.statisticsData) {
				return {
					selectedMgr: this.statisticsData[1] ? this.statisticsData[1] : '',
					selectedSls: this.statisticsData[0] ? this.statisticsData[0] : '',
					afterHrs: this.statisticsData[2] ? this.statisticsData[2] : '',
					selectedSft: this.statisticsData[3] ? this.statisticsData[3] : ''
				};
			}
			return {};

		},
		selectedMgr: {
			get: function() {
				if (this.statisticsData) return this.datasSettings.selectedMgr;
				return '';
			},
			set: function(val) {
				console.info(val);
				Object.assign(this.datasSettings.selectedMgr, val);
				this.$store.dispatch("mngr", val);
			}
		},
		selectedSls: {
			get: function() {
				if (this.statisticsData) return this.datasSettings.selectedSls;
				return '';
			},
			set: function(val) {
				Object.assign(this.datasSettings.selectedSls, val);
				this.$store.dispatch("sls", val);
			}
		},
		afterHrs: {
			get: function() {
				if (this.statisticsData[0]) return this.datasSettings.afterHrs.phone;
				return '';
			},
			set: function(val) {
				this.$store.dispatch("hrs", val);
				this.datasSettings.afterHrs.phone = val;
			}
		},
		selectedSft: {
			get: function() {
				if (this.statisticsData) return this.datasSettings.selectedSft;
				return '';
			},
			set: function(val) {
				Object.assign(this.datasSettings.selectedSft, val);
				this.$store.dispatch("sft", val);
			}
		}

	},
	methods: {
		setSettingsData(val) {
			if (/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/g.test(this.hrs))
				this.$emit("set-statistic-data", val);
		},
		log() {

		},
		editItem() {
			this.edit = !this.edit;
		},
		afterHoursPhone(evt) {
			const regex = new RegExp("^[0-9-]+$");
			const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
@import "./static-list.component";
</style>
